import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('customer.routes.index'),
        name: 'customer.index',
        component: () =>
            import(
                /* webpackChunkName: "customers" */ '@/views/customers/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('customer.breadcrumbs.index'),
                    to: { name: 'customer.index' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('customer.routes.edit') + '/:id',
        name: 'customer.edit',
        component: () =>
            import(
                /* webpackChunkName: "customers" */ '@/views/customers/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('customer.breadcrumbs.index'),
                    to: { name: 'customer.index' },
                    disable: false,
                },
                {
                    text: i18n.t('customer.breadcrumbs.edit'),
                    to: { name: 'customer.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('customer.routes.show') + '/:id',
        name: 'customer.show',
        component: () =>
            import(
                /* webpackChunkName: "customers" */ '@/views/customers/Show.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('customer.breadcrumbs.index'),
                    to: { name: 'customer.index' },
                    disable: false,
                },
                {
                    text: i18n.t('customer.breadcrumbs.show'),
                    to: { name: 'customer.show' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/sincronizar-clientes-partner/:id?',
        name: 'customer.sync-partner',
        component: () =>
            import(
                /* webpackChunkName: "customers" */ '@/views/customers/SyncCustomers.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('customer.breadcrumbs.index'),
                    to: { name: 'customer.index' },
                    disable: false,
                },
            ],
        },
        props: true,
    },
]
